import { h } from "preact";

export const FilterIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.62012 4.31006C8.92012 4.86006 8.92012 5.50006 8.67012 6.07006C8.67012 6.08006 8.66012 6.09006 8.66012 6.10006H19.2001V4.31006H8.62012Z"
      fill="currentColor"
    />
    <path
      d="M5.1298 4.31006H0.799805V6.23006H5.18981C5.0098 5.62006 5.0998 4.96006 5.1298 4.31006Z"
      fill="currentColor"
    />
    <path
      d="M19.1904 9.10986H15.1904V10.8999H19.1904V9.10986Z"
      fill="currentColor"
    />
    <path
      d="M7.88957 9.10986H0.80957V10.8999H7.88957V9.10986Z"
      fill="currentColor"
    />
    <path d="M3.44957 13.77H0.80957V15.56H3.44957V13.77Z" fill="currentColor" />
    <path d="M19.1603 13.77H8.28027V15.56H19.1603V13.77Z" fill="currentColor" />
    <path
      d="M7 8.27002C5.35 8.27002 4 6.93002 4 5.27002C4 3.62002 5.34 2.27002 7 2.27002C8.65 2.27002 10 3.61002 10 5.27002C10 6.92002 8.65 8.27002 7 8.27002ZM7 3.63002C6.1 3.63002 5.36 4.37002 5.36 5.27002C5.36 6.17002 6.1 6.91002 7 6.91002C7.9 6.91002 8.64 6.17002 8.64 5.27002C8.64 4.37002 7.91 3.63002 7 3.63002Z"
      fill="currentColor"
    />
    <path
      d="M12.6504 13C11.0004 13 9.65039 11.66 9.65039 10C9.65039 8.35 10.9904 7 12.6504 7C14.3004 7 15.6504 8.34 15.6504 10C15.6504 11.65 14.3004 13 12.6504 13ZM12.6504 8.36C11.7504 8.36 11.0104 9.1 11.0104 10C11.0104 10.9 11.7504 11.64 12.6504 11.64C13.5504 11.64 14.2904 10.9 14.2904 10C14.2904 9.1 13.5604 8.36 12.6504 8.36Z"
      fill="currentColor"
    />
    <path
      d="M5.62012 17.6699C3.97012 17.6699 2.62012 16.3299 2.62012 14.6699C2.62012 13.0199 3.96012 11.6699 5.62012 11.6699C7.27012 11.6699 8.62012 13.0099 8.62012 14.6699C8.62012 16.3199 7.27012 17.6699 5.62012 17.6699ZM5.62012 13.0299C4.72012 13.0299 3.98012 13.7699 3.98012 14.6699C3.98012 15.5699 4.72012 16.3099 5.62012 16.3099C6.52012 16.3099 7.26012 15.5699 7.26012 14.6699C7.26012 13.7699 6.53012 13.0299 5.62012 13.0299Z"
      fill="currentColor"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    class="icon icon--close"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.57062 10.8104L10.8341 9.54713L15.7111 14.4315L14.4477 15.6948L9.57062 10.8104Z"
      fill="currentColor"
    />
    <path
      d="M0.308303 1.5501L1.55756 0.300837L8.00732 6.74855L14.456 0.313345L15.6854 1.54276L1.5432 15.6848L0.313781 14.4554L6.75816 7.9979L0.308303 1.5501Z"
      fill="currentColor"
    />
  </svg>
);

export const RemoveIcon = () => (
  <svg
    class="icon icon--remove"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 5.78261L12.7826 0L14 1.21739L8.21739 7L14 12.7826L12.7826 14L7 8.21739L1.21739 14L0 12.7826L5.78261 7L0 1.21739L1.21739 0L7 5.78261Z"
    />
  </svg>
);

export const CaretIcon = () => (
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 1L7 7L1 1"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    class="icon icon--search"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.81641 10.6738C1.81641 6.14639 5.4866 2.4762 10.014 2.4762C14.5414 2.4762 18.2116 6.14639 18.2116 10.6738C18.2116 15.2012 14.5414 18.8714 10.014 18.8714C5.4866 18.8714 1.81641 15.2012 1.81641 10.6738ZM10.014 1.4762C4.93432 1.4762 0.816406 5.59411 0.816406 10.6738C0.816406 15.7535 4.93432 19.8714 10.014 19.8714C15.0937 19.8714 19.2116 15.7535 19.2116 10.6738C19.2116 5.59411 15.0937 1.4762 10.014 1.4762ZM17.4871 19.0515L23.9253 25.4897L24.6324 24.7825L18.1942 18.3443L17.4871 19.0515Z"
    ></path>
  </svg>
);

export const Minus = () => (
  <svg
    class="icon icon--minus"
    width="12"
    height="2"
    viewBox="0 0 12 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 1.75V0.25L0 0.25L0 1.75L12 1.75Z" fill="black" />
  </svg>
);

export const Plus = () => (
  <svg
    class="icon icon--plus"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4191 6.43506H0.588867V7.77459H13.4191V6.43506Z"
      fill="currentColor"
    />
    <path
      d="M7.8239 0.588379H6.5332V7.00001H7.8239V0.588379Z"
      fill="currentColor"
    />
    <path
      d="M7.8239 9.02295H6.5332V13.4113H7.8239V9.02295Z"
      fill="currentColor"
    />
  </svg>
);

export const SelectedCheck = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="24" height="24" rx="12" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2826 13.9537L10.269 13.9676L9.76758 13.447L9.4989 13.1826L9.50601 13.1754L6.99367 10.5668L5 12.6073L10.269 18L12.2913 15.9302L10.2826 13.9537ZM12.0297 12.1656L14.0384 14.1421L20 8.04049L18.0538 6L12.0297 12.1656Z"
      fill="black"
    />
  </svg>
);

export const SelectedCheckSmall = ({ className = "" }) => (
  <svg
    className={className}
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.26899 8.46761L13.0538 0.5L15 2.54049L5.26899 12.5L0 7.10729L1.99367 5.0668L5.26899 8.46761Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowUp = () => (
  <svg
    width="17"
    height="8"
    viewBox="0 0 17 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M-0.000976562 8L8.9537 0L10.1744 1.29914L2.73809 8"
      fill="#1D1D1B"
    />
    <path
      d="M9.14307 2.76188L14.5471 7.99837H16.9989L10.4401 1.57031L9.14307 2.76188Z"
      fill="#1D1D1B"
    />
  </svg>
);

export const ArrowDown = () => (
  <svg
    width="17"
    height="8"
    viewBox="0 0 17 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="#1D1D1B" d="M17,0L8,8L6.8,6.7L14.3,0" />
    <path fill="#1D1D1B" d="M7.9,5.2L2.5,0H0l6.6,6.4L7.9,5.2z" />
  </svg>
);

export const ArrowLeft = () => (
  <svg
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.3 6L6.3 0H8.1L2.7 5.4H15V6.6H2.7L8.1 12H6.3L0.3 6Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowRight = () => (
  <svg
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7 6L8.7 0H6.9L12.3 5.4H0V6.6H12.3L6.9 12H8.7L14.7 6Z"
      fill="currentColor"
    />
  </svg>
);

export const FaqIcon = () => (
  <svg
    class="icon icon--faq"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.32744 9.34335V9.39526H7.39841C7.3812 9.28279 7.364 9.17031 7.364 9.04053C7.364 8.58197 7.55324 8.15801 8.04357 7.78597L8.45647 7.4745C8.71454 7.28415 8.82636 7.05055 8.82636 6.79098C8.82636 6.39299 8.54249 6.0123 7.96615 6.0123C7.3554 6.0123 7.08873 6.50546 7.08873 6.98998C7.08873 7.09381 7.09733 7.18898 7.12314 7.26685L6.03927 7.22359C6.00486 7.10246 5.99626 6.96403 5.99626 6.83424C5.99626 5.89982 6.69303 5 7.96615 5C9.29948 5 9.99626 5.84791 9.99626 6.72177C9.99626 7.40528 9.65217 7.8898 9.14464 8.25319L8.79195 8.5041C8.49088 8.7204 8.32744 8.98862 8.32744 9.34335ZM7.88013 11.3333C7.50163 11.3333 7.20056 11.0305 7.20056 10.6498C7.20056 10.2691 7.50163 9.95765 7.88013 9.95765C8.25862 9.95765 8.5683 10.2691 8.5683 10.6498C8.5683 11.0305 8.25862 11.3333 7.88013 11.3333Z"
      fill="black"
    />
    <path
      d="M0.667557 8.00033C0.775 3.95166 3.9508 0.666992 8.00089 0.666992C12.051 0.666992 15.3342 3.95024 15.3342 8.00033C15.3342 12.0504 12.051 15.3337 8.00089 15.3337C7.24949 15.3337 6.39665 15.0417 5.67158 14.7936L5.67156 14.7936C5.10773 14.6006 4.62115 14.434 4.31963 14.4518C4.10292 14.4531 3.60904 14.5929 3.31348 14.6765L3.30552 14.6788L0.667557 15.3337L1.37449 12.8674C1.47875 12.5147 1.57018 12.1701 1.57018 11.9461L1.54914 11.7422H2.87904C2.87904 12.458 2.54215 13.6031 2.54215 13.6031C2.54215 13.6031 3.71097 13.1193 4.31963 13.1462C4.69918 13.163 4.94398 13.1987 5.23578 13.3495C6.05994 13.7756 7.00914 14.0003 8.00089 14.0003C11.3146 14.0003 14.0009 11.314 14.0009 8.00033C14.0009 4.68662 11.3146 2.00033 8.00089 2.00033C4.68718 2.00033 2.00089 4.68662 2.00089 8.00033C2.00089 8.69506 2.12816 9.37381 2.34215 10.0003H1.01659C0.817762 9.39527 0.647974 8.73828 0.667557 8.00033Z"
      fill="black"
    />
  </svg>
);

export const WarrantyIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6942_22226)">
      <path
        d="M13.0582 1.64488V0H11.706V4.53459C11.706 5.77129 11.3576 6.89224 10.6964 7.69032C10.0193 8.50666 9.07498 8.93921 7.96634 8.93921C6.85771 8.93921 5.91339 8.50666 5.23633 7.69032C4.57511 6.89224 4.21282 5.77129 4.21282 4.53459V1.37073H10.3935V0H2.8785V1.64488H0V4.57926C0 6.12667 1.22742 7.38571 2.73596 7.38571H3.47835C3.6783 7.82028 3.92774 8.22033 4.22074 8.57571C5.00668 9.52405 6.08562 10.1109 7.3071 10.2673V14.5419H4.89384V15.9127H11.0824V14.5419H8.6434V10.2673C9.85895 10.1089 10.9319 9.52405 11.7159 8.57774C12.0089 8.22236 12.2584 7.82231 12.4583 7.38774H13.264C14.7726 7.38774 16 6.1287 16 4.58129V1.64691H13.0582V1.64488ZM2.73596 6.01498C1.96387 6.01498 1.3363 5.37124 1.3363 4.57926V3.01561H2.8785V4.53255C2.8785 5.04226 2.92997 5.53979 3.02895 6.01498H2.73596ZM14.6637 4.57926C14.6637 5.37124 14.0361 6.01498 13.264 6.01498H12.9077C13.0067 5.53979 13.0582 5.04429 13.0582 4.53255V3.01561H14.6637V4.57926Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_6942_22226">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CaretDown = () => (
  <svg
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1.47152L1.48211 0.109375L7.01538 5.2986L12.5407 0.109375L14 1.47152L7.01538 8.10938L0 1.47152Z"
      fill="black"
    />
  </svg>
);

export const Spinner = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 612 612"
    className="icon--spinner"
    style="enable-background:new 0 0 612 612;"
  >
    <circle
      style="opacity:0.1"
      fill="#000000"
      class="st0"
      cx="304.8"
      cy="313.5"
      r="256.4"
    />
    <path
      fill="#FEDD2F"
      d="M247.8,99.8c0,0,1.1-2.6,26.7-6.4c21.1-3.4,28.2-3,31.2-2.9c4.4,0.1,6.9,0.1,26.2,2.3s30.6,5.7,30.6,5.7
    l0.6,79.6l-52.9,89.2l-5.1,3.2l-5.7-3.2l-52.9-88.5L247.8,99.8z"
    />
  </svg>
);

export const Play = () => (
  <svg
    width="8"
    height="9"
    viewBox="0 0 8 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="icon--play"
  >
    <path
      d="M7.5 4.5L0.75 8.39711L0.75 0.602885L7.5 4.5Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowUpRightBox = () => (
  <svg
    class="icon--arrow-up-right-box"
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7099 12.8691H3.16992V4.11914H9.02992L10.2799 2.86914H1.91992V14.1191H13.9599V6.88914L12.7099 8.13914V12.8691Z"
      fill="currentColor"
    />
    <path
      d="M9.88994 0L8.82994 1.07H15.2199L14.7299 1.56L13.6799 2.61L7.93994 8.35L8.64994 9.06L14.2399 3.47L15.2899 2.42L15.9299 1.78V8.17L16.9999 7.11V0H9.88994Z"
      fill="currentColor"
    />
  </svg>
);

export const DirectionsIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.5 0V2.02054C4.5851 2.26101 2.26101 4.5851 2.02054 7.5H0V8.5H2.02054C2.26101 11.4149 4.5851 13.739 7.5 13.9795V16H8.5V13.9795C11.4149 13.739 13.739 11.4149 13.9795 8.49999L16 8.5V7.5H13.9795C13.739 4.5851 11.4149 2.26101 8.5 2.02054V0H7.5ZM3 8C3 5.23858 5.23858 3 8 3C10.7614 3 13 5.23858 13 8C13 10.7614 10.7614 13 8 13C5.23858 13 3 10.7614 3 8Z"
      fill="currentColor"
    />
    <path
      d="M8 4.5C6.067 4.5 4.5 6.067 4.5 8C4.5 9.933 6.067 11.5 8 11.5C9.933 11.5 11.5 9.933 11.5 8C11.5 6.067 9.933 4.5 8 4.5Z"
      fill="currentColor"
    />
  </svg>
);

export const PhoneIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.57993 3.63215C2.23658 4.10391 2.26058 4.70827 2.62926 5.51785L1.71924 5.93164C1.19456 4.7809 1.20456 3.82006 1.74857 3.07844C1.95124 2.73928 3.22528 1.2647 4.3193 1.336C4.66331 1.36465 4.97799 1.52457 5.27333 1.81242C5.588 2.11959 6.90937 3.72677 7.01537 4.23518C7.12928 4.78175 6.8838 5.2086 6.7045 5.52037L6.70403 5.52118C6.52736 5.82836 6.46602 5.95963 6.52669 6.12554C6.9727 7.21632 7.66206 8.10786 8.56941 8.75553L7.9874 9.56911C6.9247 8.80883 6.11935 7.77136 5.59334 6.48469C5.362 5.84835 5.63667 5.37126 5.83734 5.02277C5.98801 4.76157 6.07135 4.60565 6.03601 4.43907C5.94268 4.19853 4.96799 2.91186 4.57464 2.52872C4.45331 2.40945 4.3393 2.33948 4.25463 2.33282C3.77729 2.32149 2.80126 3.26501 2.57993 3.63215Z"
      fill="currentColor"
    />
    <path
      d="M11.7644 8.98214C12.2751 9.08808 13.8811 10.4087 14.1885 10.7226C14.4778 11.0184 14.6378 11.3336 14.6652 11.6581C14.7085 12.8861 13.0638 14.1695 12.8751 14.2774C12.5164 14.536 12.0958 14.6666 11.6224 14.6666C11.1517 14.6666 10.6291 14.5373 10.063 14.2734C7.88632 13.3699 4.59423 10.4401 2.74219 7.75143L3.56554 7.18506C5.29559 9.69644 8.45567 12.5237 10.4664 13.3592C11.2797 13.737 11.8851 13.7604 12.3358 13.4372C12.6871 13.2246 13.6851 12.2331 13.6671 11.7174C13.6611 11.6568 13.5918 11.5428 13.4738 11.4222C13.0898 11.0291 11.8011 10.0543 11.5317 9.95297C11.3191 9.90766 11.0977 10.0369 10.7604 10.2495L10.5897 10.3554L10.0737 9.49921L10.2277 9.40392C10.6011 9.16871 11.1164 8.84754 11.7644 8.98214Z"
      fill="currentColor"
    />
  </svg>
);

export const DistanceIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99963 1.3335H8.02188C11.1461 1.34577 13.6785 3.89481 13.6663 7.01504V7.07701C13.6241 9.30684 12.2836 11.1572 11.1666 12.3166C10.8487 12.6481 10.5104 12.9661 10.1615 13.2631L9.5158 12.5072C9.83894 12.2318 10.1533 11.936 10.4489 11.6279C11.4429 10.5966 12.6348 8.96599 12.6711 7.05889C12.681 4.43911 10.5941 2.33733 8.01778 2.3268H7.99963C5.43209 2.3268 3.33813 4.40813 3.32818 6.97412C3.37208 8.24162 3.80059 9.44657 4.56805 10.4574C5.4637 11.6501 6.8224 12.9129 8.11378 13.7536L7.57054 14.5861C6.18783 13.6864 4.73254 12.3335 3.77308 11.0561C2.88269 9.88271 2.38452 8.48249 2.33301 7.00861C2.3453 3.85739 4.88533 1.3335 7.99963 1.3335Z"
      fill="currentColor"
    />
    <path
      d="M6.83697 7.07618C6.83697 7.7152 7.35797 8.23611 7.99839 8.23611C8.63881 8.23611 9.15981 7.7152 9.15981 7.07618C9.15981 6.43658 8.63881 5.91567 7.99839 5.91567V4.92236C9.18733 4.92236 10.155 5.88819 10.155 7.07618C10.155 8.26359 9.18733 9.22942 7.99839 9.22942C6.80945 9.22942 5.8418 8.26359 5.8418 7.07618H6.83697Z"
      fill="currentColor"
    />
  </svg>
);

export const VeerChevronIcon = () => (
  <svg
    width="41"
    height="47"
    viewBox="0 0 41 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 46.2595V33.3099L40.7945 16.6719V29.5985L0 46.2595Z"
      fill="currentColor"
    />
    <path
      d="M37.853 15.4567L0 0V12.9463L21.996 21.9233L37.853 15.4567Z"
      fill="currentColor"
    />
  </svg>
);
